import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { Navbar } from './Navbar';
import { Footer } from './Footer';
import { GoogleTagManager } from '../GoogleTagManager';

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

export const Layout = ({ children }) => {
  return (
    <div className="min-h-screen flex flex-col">
      <GoogleTagManager />
      <ScrollToTop />
      <Navbar />
      <main className="flex-1 pt-28">
        {children}
      </main>
      <Footer />
    </div>
  );
};
